// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-2VCua";
var _3 = "details-8jgRN";
var _4 = "item-2SBEh";
var _5 = "totalRefund-1KwKk";
export { _1 as "__esModule", _2 as "root", _3 as "details", _4 as "item", _5 as "totalRefund" }
export default { "__esModule": _1, "root": _2, "details": _3, "item": _4, "totalRefund": _5 }
